import { GetSiteData, SiteData, TeamData, TeamResults, DataUtils, ImageSize, Grades } from '../clients/data-service';
import React from "react";
import {
    Box,
    Card,
    CardBody,
    Heading,
    Image,
    SimpleGrid,
    Stack,
    Skeleton,
    Badge,
    Flex,
    Spacer,
    filter
} from '@chakra-ui/react';
import { Link as ReactLink } from "react-router-dom";
import { ImagePeopleListing } from './ImagePeopleListing';
import { BuildQuery, FilterState, FilterTeams, GetPlayerFilterHighlightString } from '../utilities/TeamFiltering';

export type TeamGridProps = {
    filter: FilterState;
};

export type TeamGridState = {
    data?: SiteData
};



class TeamSquare extends React.Component<{teamData: TeamData, siteData: SiteData, filter?: FilterState, playerFilter?: string}> {
    render() {
        const team = this.props.teamData;
        const siteData = this.props.siteData;
        const badgeStyle = 'outline';
        const linkQuery = this.props.filter ? BuildQuery(this.props.filter) : "";
        const bestImageDescriptor = DataUtils.BestTeamImageDescriptor(siteData, team);
        return <Card w="fill" maxW={'1400px'} key={team.id} variant='elevated'>
            <ReactLink to={`/team/${team.id}?${linkQuery}`}>
                <Image objectFit='cover' w="100%"  borderRadius='lg' 
                        src={DataUtils.BestTeamImage(siteData, team, ImageSize.Medium)} 
                        // srcSet={DataUtils.BestTeamImage(siteData, team, ImageSize.SrcSet)}  
                        // sizes={DataUtils.BestTeamImage(siteData, team, ImageSize.SrcSetSizes)}  
                        // fallbackSrc='/logoplaceholder512.png'  
                        fallback={<Image src={DataUtils.BestTeamImage(siteData, team, ImageSize.Small)} fallbackSrc='/logoplaceholder512.png' />}
                />
                <CardBody>
                    <Stack spacing='6'>
                        <Flex>
                            <Heading size='md'>{DataUtils.TeamName(team)}</Heading>
                            <Spacer/>
                            <Box textAlign='right'>
                                {team.result &&<Badge  colorScheme='orange' variant={badgeStyle}>{DataUtils.LookupDisplay(TeamResults(), team.result!)}</Badge>}
                                {team.minor_premiers &&<Badge  ml={1}  colorScheme='orange' variant={badgeStyle}>Minor Premiers</Badge>}
                            </Box>
                        </Flex>
                        {bestImageDescriptor && <ImagePeopleListing descriptor={bestImageDescriptor} compact={true} playersToHighlight={this.props.playerFilter ? [this.props.playerFilter] : []}/>}
                    </Stack>
                </CardBody>
            </ReactLink>
        </Card>;
        
    }
}

export class TeamGrid extends React.Component<TeamGridProps, TeamGridState> {
    constructor(props) {
        super(props);
        this.state = {
            data: undefined,
        };

        async function LoadData (comp) {
            const data = await GetSiteData();
            comp.setState({
                data: data,
            });
        }
        LoadData(this);
    }

    render() {
        let siteData = this.state?.data;
        if (siteData == null) {
            return (
                <Stack w="fill">
                    <Skeleton height='100px' />
                    <Skeleton height='100px' />
                    <Skeleton height='100px' />
                </Stack>
            );
        }

        let filteredTeams = siteData.Teams;
        let pfs: string|undefined = undefined;
        if (this.props?.filter) {
            filteredTeams = FilterTeams(siteData, this.props.filter);
            pfs = GetPlayerFilterHighlightString(this.props.filter, siteData);
        }
        
        return (<>
            <SimpleGrid w="fill" minChildWidth={{ base: '280px', md: '400px' }}  spacing={{ base: 2, md: 6 }}>
                {filteredTeams.map(t => <TeamSquare key={t.id} teamData={t} siteData={siteData!} playerFilter={pfs} filter={this.props?.filter} />)}
            </SimpleGrid>
        </>);
    }
}
